import ScenarioHeader from './components/header/ScenarioHeader'
import ScenarioTimelineContainer from './components/scenario-timeline/ScenarioTimelineContainer'
import Visualization from './components/visualization/Visualization'
import ModalProviders from './providers/ModalProviders'
import ScenarioDataProvider from './providers/ScenarioDataProvider'
import SocketProvider from './providers/SocketProvider'
import StatesProvider from './providers/StatesProvider'
import ViewerProvider from './providers/ViewerProvider'
import './Scenario.scss'

const Scenario = () => {
    return (
        <main className='scenario__page__wrapper'>
            <StatesProvider>
                <ScenarioDataProvider>
                    <SocketProvider>
                        <ViewerProvider>
                            <ModalProviders>
                                <ScenarioHeader />
                                <Visualization />
                                <ScenarioTimelineContainer />
                            </ModalProviders>
                        </ViewerProvider>
                    </SocketProvider>
                </ScenarioDataProvider>
            </StatesProvider>
        </main>
    )
}

export default Scenario